// extracted by mini-css-extract-plugin
module.exports = {"search-content-root":"SearchContent_search-content-root__3A4Re"};